// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var IsNewQueryParam = require("./IsNewQueryParam.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var TeamMarketingProfileLogoForm = require("./TeamMarketingProfileLogoForm.bs.js");
var TeamMarketingProfileTeamPhotoForm = require("./TeamMarketingProfileTeamPhotoForm.bs.js");
var TeamMarketingProfilePhotosSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfilePhotosSettingsQuery_graphql.bs.js");

function TeamMarketingProfilePhotosSettings$Header(props) {
  var match = IsNewQueryParam.use();
  var displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  var breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("Photos"),
      href: MarketingProfileSubpages.Page.Team.path("Photos")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: displayName("Photos"),
                              className: "text-zinc-800 text-3xl font-medium"
                            }),
                        (function (__x) {
                              return ReactRender.ifTrue(JsxRuntime.jsx("p", {
                                              children: "Your team's marketing profile is now active. Let's start adding more information to it. You can come back at any time to finish.",
                                              className: "text-base text-zinc-500"
                                            }), __x);
                            })(match[0])
                      ],
                      className: "space-y-2"
                    })
              ],
              className: "space-y-3"
            });
}

var Header = {
  make: TeamMarketingProfilePhotosSettings$Header
};

var convertVariables = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

var convertResponse = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, TeamMarketingProfilePhotosSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfilePhotosSettings(props) {
  var match = use(undefined, undefined, undefined, undefined);
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var match$1 = IsNewQueryParam.use();
  var subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  var nextPage = Core__Option.flatMap(Core__Array.findIndexOpt(subpages, (function (param) {
              return param.page === "Photos";
            })), (function (i) {
          return subpages[i + 1 | 0];
        }));
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(TeamMarketingProfilePhotosSettings$Header, {}),
                                className: "pb-2"
                              }),
                          JsxRuntime.jsx(TeamMarketingProfileLogoForm.make, {
                                teamMarketingProfile: marketingProfile.fragmentRefs
                              }),
                          (function (__x) {
                                return ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileTeamPhotoForm.make, {
                                                teamMarketingProfile: marketingProfile.fragmentRefs
                                              }), __x);
                              })(hasFullProfile)
                        ],
                        className: "space-y-8 sm:space-y-0 divide-y divide-zinc-200"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                                target: "_blank",
                                children: "View Profile"
                              }),
                          match$1[0] && nextPage !== undefined ? JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                        href: nextPage.path + "?is_new=1",
                                        children: "Continue"
                                      }),
                                  className: "flex items-baseline gap-6"
                                }) : null
                        ],
                        className: "flex justify-between border-t border-zinc-200 pt-4"
                      })
                ],
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = TeamMarketingProfilePhotosSettings;

exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
